/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable react/no-danger */
import React, { useMemo, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Detector from '../partials/Detector';

import { replaceIcons } from '../../lib/utils';

import styles from '../../../styles/blocks/title.module.scss';

const propTypes = {
    size: PropTypes.oneOf(['xlarge', 'large', 'medium', 'small', 'xsmall']),
    body: PropTypes.string,
    colors: PropTypes.shape({
        type: PropTypes.oneOf(['none', 'color', 'gradient']),
        colors: PropTypes.arrayOf(PropTypes.string),
    }),
    className: PropTypes.string,
    titleClassName: PropTypes.string,
    isContainer: PropTypes.bool,
    containerClassName: PropTypes.string,
};

const defaultProps = {
    size: 'large',
    body: null,
    colors: {
        type: 'none',
        colors: [],
    },
    className: null,
    isContainer: false,
    titleClassName: null,
    containerClassName: null,
};

const TitleBlock = ({
    size,
    body,
    colors,
    className,
    isContainer,
    titleClassName,
    containerClassName,
}) => {
    const [visible, setVisible] = useState(false);
    const Tag = useMemo(() => (size === 'medium' ? 'h3' : 'h1'), [size]);
    const { type: colorType = null, colors: customColors = [] } = colors || {};
    const isGradient = colorType === 'gradient';

    const colorStyles = useMemo(() => {
        if (colorType === 'color') return { color: customColors[0] };
        if (colorType === 'gradient')
            return {
                backgroundImage: `linear-gradient(to bottom, #FFF, #FFF, ${customColors[0]}, ${customColors[1]}, #FFF)`,
            };
        return null;
    }, [colorType, customColors]);

    const onEnter = useCallback(() => {
        setVisible(true);
    }, [setVisible]);

    const finalBody = replaceIcons(body);

    return (
        <Detector onEnter={onEnter}>
            <div
                className={classNames([
                    styles.container,
                    {
                        [styles.visible]: visible,
                        [styles.animated]: isGradient,
                        [styles.isGradient]: isGradient,
                        // [styles.withMargin]: size === 'large',
                        [className]: className !== null,
                    },
                ])}
            >
                <div
                    className={classNames([
                        styles.inner,
                        {
                            [styles.isContainer]: isContainer,
                            [containerClassName]: isContainer && containerClassName !== null,
                        },
                    ])}
                >
                    {body !== null ? (
                        <Tag
                            className={classNames([
                                styles.title,
                                {
                                    [styles[size]]: size !== null,
                                    [titleClassName]: titleClassName !== null,
                                },
                            ])}
                            style={colorStyles}
                            dangerouslySetInnerHTML={{ __html: finalBody }}
                        />
                    ) : null}
                </div>
            </div>
        </Detector>
    );
};

TitleBlock.propTypes = propTypes;
TitleBlock.defaultProps = defaultProps;

export default TitleBlock;
